import { useCustomSearchParams } from 'hooks/useCustomSearchParams';
import { useGetOrdersStatistic } from 'api/statisticApi';
import ColumnChart from '../../ColumnChart';

export default function StatisticOrderQuantity() {
  const [search] = useCustomSearchParams();
  const { data, isLoading } = useGetOrdersStatistic({ params: search });

  if (isLoading) {
    return null;
  }

  return <ColumnChart title="Số lượng Order" data={data} />;
}
